import { defineStore } from 'pinia';

import { getModules as getModulesAPI } from '@/api/module';

export const useModuleStore = defineStore('module', {
  state: () => ({
    modules: [],
  }),

  actions: {
    async getModules() {
      return await getModulesAPI().then((response) => {
        // console.log('Loaded modules:', response);
        this.$patch({
          modules: response,
        });
      });
    },
  },
});
